<template>
  <div v-if="nodeList.length > 0 && $route.meta.menu.gridId !== 'showDeleteRecord'" class="breadcrumb">
    <template v-for="(item, i) in nodeList">
      <a v-if="i < nodeList.length - 1" @click="handleClick(item)" href="javascript:" class="breadcrumb-item is-link">{{ item.name }}</a>
      <i v-if="i < nodeList.length - 1" class="mng icon-lineArrR-stroke"></i>
      <span v-if="i === nodeList.length - 1" class="breadcrumb-item">{{ item.name }}</span>
    </template>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'crumbs-nav',
    computed: {
      nodeList() {
        let nodeList = []
        let menu = this.$route.meta.menu
        if (menu && menu.showInLeftMenu === '0') {
          nodeList.push(menu)
          while (menu.parent) {
            nodeList.push(menu.parent)
            menu = menu.parent
          }
        }
        nodeList.reverse()
        return nodeList
      }
    },
    methods: {
      handleClick(node) {
        let routerName = node.routerName || node.id
        util.routerBack(this, routerName)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/crumbs-nav/crumbs-nav.vue